import { cn } from '@/shared/utils/cn'

function Row() {
  return (
    <div className="flex items-center gap-4 px-2 py-3">
      <div className="h-11 w-11 animate-pulse rounded-full bg-surface" />
      <div className="flex-1 space-y-2">
        <div className="h-4 w-2/3 animate-pulse rounded bg-surface" />
        <div className="h-3 w-1/3 animate-pulse rounded bg-surface" />
      </div>
      <div className="h-6 w-16 animate-pulse rounded-full bg-surface" />
    </div>
  )
}

export function BusinessesListSkeleton({ count = 5, className }: { count?: number; className?: string }) {
  return (
    <div className={cn('divide-y divide-line', className)}>
      {Array.from({ length: count }, (_, i) => (
        <Row key={i} />
      ))}
    </div>
  )
}
